/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type courses_AttendanceResponse = {
    /**
     * Amount in minor currency units (e.g., 2500 = 25.00 in major units)
     */
    amount?: number;
    attendance_date?: string;
    billed_at?: string;
    /**
     * BillingType override at attendance level
     */
    billing_type?: courses_AttendanceResponse.billing_type;
    child_avatar_url?: string;
    child_firstname?: string;
    child_id?: string;
    child_lastname?: string;
    comments?: string;
    course_name?: string;
    course_plan_id?: string;
    created_at?: string;
    /**
     * EnrollmentBillingType from the enrollment record
     */
    enrollment_billing_type?: courses_AttendanceResponse.enrollment_billing_type;
    enrollment_id?: string;
    id?: string;
    invoice_id?: string;
    /**
     * PricePerMonth in minor currency units (e.g., 10000 = 100.00 in major units)
     */
    price_per_month?: number;
    /**
     * PricePerUnit in minor currency units (e.g., 2500 = 25.00 in major units)
     */
    price_per_unit?: number;
    schedule_display?: string;
    status?: string;
    version?: number;
};
export namespace courses_AttendanceResponse {
    /**
     * BillingType override at attendance level
     */
    export enum billing_type {
        PER_MONTH = 'per_month',
        PER_UNIT = 'per_unit',
        FREE = 'free',
    }
    /**
     * EnrollmentBillingType from the enrollment record
     */
    export enum enrollment_billing_type {
        PER_MONTH = 'per_month',
        PER_UNIT = 'per_unit',
        FREE = 'free',
    }
}

